export default __webpack_public_path__ + "static/media/become.39864b02.png";